/*!
 * devextreme-angular
 * Version: 19.1.3
 * Build date: Tue May 14 2019
 *
 * Copyright (c) 2012 - 2019 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/* tslint:disable:max-line-length */

import { NestedOption } from '../../../core/nested-option';


export abstract class DxoHtmlEditorMediaResizing extends NestedOption {
    get allowedTargets(): Array<string> {
        return this._getOption('allowedTargets');
    }
    set allowedTargets(value: Array<string>) {
        this._setOption('allowedTargets', value);
    }

    get enabled(): boolean {
        return this._getOption('enabled');
    }
    set enabled(value: boolean) {
        this._setOption('enabled', value);
    }
}
